import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import React from 'react'
import type {RootLoaderResponse} from '~/types'
import {cssDomains} from '~/utils/constants'

interface CompanyInfoProps extends HTMLAttributes<HTMLDivElement> {}

const address = {
  uk: {
    street: 'Chipperfield Road Kings Langley Hertfordshire',
    city: 'UK, WD4 9JB',
  },
}

const CompanyInfo: FunctionComponent<CompanyInfoProps> = ({...props}) => {
  const {domainName, featureFlags, locale = 'uk'} = useRouteLoaderData('root') as RootLoaderResponse
  const showCompanyInfo =
    cssDomains.includes(domainName) || featureFlags?.displayEnhancedAboutPage || featureFlags?.showImprovedHomepage

  const companyName =
    featureFlags?.displayEnhancedAboutPage || featureFlags?.showImprovedHomepage
      ? ''
      : `Roundforest ${locale.toUpperCase()} LTD`
  const companyAddress = address[locale.toLowerCase() as keyof typeof address] ?? address.uk

  return showCompanyInfo ? (
    <div {...props}>
      <span className="font-semibold">{companyName}</span>
      <div className="flex flex-col items-start justify-between gap-1 font-extralight italic">
        <span>{companyAddress.street}</span>
        <span>{companyAddress.city}</span>
      </div>
    </div>
  ) : null
}

export default CompanyInfo
